import { createContext, useContext } from 'react';

/**
 * Heading number → the Modules 2 to 5 section's REGARA guide (`sectionGuides`), read by
 * `SubsectionHeading`, which shows it in the "What belongs here" box under the heading. Only
 * `EctdRenderer` provides it, for the five U.S. medicinal types; everywhere else (the EU CTD view,
 * which shares the Module 2 to 5 components) the default empty map means no guide and unchanged
 * output. Lockstep with `_section_guides_html` in `backend/services/dossier/ectd_renderer/usa.py`.
 */
export const SectionGuidesContext = createContext<ReadonlyMap<string, string>>(new Map());

/** The Modules 2 to 5 REGARA guide for this heading, or null (none outside `EctdRenderer`). */
export function useSectionGuide(number: string): string | null {
  return useContext(SectionGuidesContext).get(number) ?? null;
}
